import React, { useEffect, useId } from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import { BaseModalContainer } from '../components/ModalContainer';
import ModalPrimitive from '../components/ModalPrimitive';
import * as styles from './VersionMismatchModal.module.scss';

const VersionMismatchModal = () => {
  const isOpen = useAppSelector((state) => state.ui.isVersionMismatchModalOpen);
  const socket = useAppSelector((state) => state.session.socket);
  const descriptionId = useId();

  useEffect(() => {
    if (isOpen) {
      socket?.disconnect();
    }
  }, [isOpen, socket]);

  return (
    <BaseModalContainer open={isOpen}>
      <ModalPrimitive.Root
        role="alertdialog"
        aria-modal="true"
        aria-label="Version mismatch"
        aria-describedby={descriptionId}
        className={styles.container}
      >
        <ModalPrimitive.Description id={descriptionId}>
          We updated Slab while you were away!
          <br />
          Please refresh your browser to get the latest.
        </ModalPrimitive.Description>
        <ModalPrimitive.Button
          variant="primary"
          onClick={() => {
            if (window.desktop?.reloadAllTabs) {
              window.desktop.reloadAllTabs();
            } else {
              document.location.reload();
            }
          }}
        >
          Get the Latest
        </ModalPrimitive.Button>
      </ModalPrimitive.Root>
    </BaseModalContainer>
  );
};

export default VersionMismatchModal;
